import { POTENCIA_MINIMA_VERTICAL } from "../constants"
import { FlatButton } from "src/framework/components/buttons/FlatButton"
import { Tooltip, IconButton, Box } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { isMobile } from "./deviceUtils";
import { JSX } from "react/jsx-runtime";

interface redirecionarParaEngenhariaProps {
  onNegation: () => void,
  onConfirmation: () => void,
}

export function redirecionarParaEngenharia({ onNegation, onConfirmation }: redirecionarParaEngenhariaProps) {  
  const customButtons: JSX.Element = isMobile() ? (<>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '12px'
      }}
    >
      <FlatButton
        style={{ width: '100%' }}
        onClick={() => {
          confirmationDialog.close()
          if (typeof onNegation === 'function') onNegation()
        }}
        color="primary"
        variant="contained"
        text={'MANTER SERVIÇO - ENVIAR PARA A ENGENHARIA'}
      />

      <FlatButton
        style={{ width: '100%' }}
        variant="outlined"
        color="secondary"
        onClick={() => {
          confirmationDialog.close()
          if (typeof onConfirmation === 'function') onConfirmation()
        }}
        text={'RETIRAR SERVIÇO - PROPOSTA SOMENTE PRODUTOS'}
      />
    </div>

  </>) : (<>
        <span className="row X--start" style={{ 
          position: 'absolute',
          zIndex: 999,
        }}>
            <Tooltip
              placement="top"
              title={(
                <>
                  <span>* Proposta na plataforma somente com valores de produtos</span><br />
                  <span>* Prazos de retorno das propostas pela engenharia</span><br />
                  <span>* Proposta Produto (acima de 1000kWp) - 3 dias</span><br />
                  <span>* Proposta Produto com Serviço - 4 dias</span><br />
                  <span>* Proposta Turnkey - 10 dias</span><br />
                </>
              )}    
            >
                <IconButton size="medium">
                  <FontAwesomeIcon icon={faInfoCircle} />
                </IconButton>
            </Tooltip>
        </span> 
        <FlatButton
          variant="outlined"
          onClick={() => {
            confirmationDialog.close()
            if (typeof onConfirmation === 'function') onConfirmation()
          }}
          color="secondary"
          text={'Retirar serviço - Proposta somente produtos'}
        />
        <Tooltip 
          arrow 
          title={``}
        >
          <FlatButton
            onClick={() => {
              confirmationDialog.close()
              if (typeof onNegation === 'function') onNegation()
            }}
            color="primary"
            variant="contained"
            text={'Manter Serviço - Enviar para a Engenharia'}
          />
        </Tooltip>
      </>);
  confirmationDialog.setup({
    title: 'Atenção!',
    subtitle: `Seu projeto está acima de ${POTENCIA_MINIMA_VERTICAL} kWp`,
    content: (
      <>
        <p>Escolha uma das opções para seguir com o seu projeto:</p>
      </>
    ),
    onClose: () => {
    },
    onNegation: () => {
      confirmationDialog.close()
    },
    onConfirmation: () => {
      confirmationDialog.close()
    },
    customButtons: customButtons
  })

  confirmationDialog.open()
}